import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoicingCategory\UpdateMultipleInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/UpdateMultipleInvoicingCategoryController.php
* @route '/api/invoicing-category/multiple-invoicing-update'
*/
const UpdateMultipleInvoicingCategoryController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateMultipleInvoicingCategoryController.url(options),
    method: 'post',
})

UpdateMultipleInvoicingCategoryController.definition = {
    methods: ["post"],
    url: '/api/invoicing-category/multiple-invoicing-update',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\InvoicingCategory\UpdateMultipleInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/UpdateMultipleInvoicingCategoryController.php
* @route '/api/invoicing-category/multiple-invoicing-update'
*/
UpdateMultipleInvoicingCategoryController.url = (options?: RouteQueryOptions) => {
    return UpdateMultipleInvoicingCategoryController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoicingCategory\UpdateMultipleInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/UpdateMultipleInvoicingCategoryController.php
* @route '/api/invoicing-category/multiple-invoicing-update'
*/
UpdateMultipleInvoicingCategoryController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UpdateMultipleInvoicingCategoryController.url(options),
    method: 'post',
})

export default UpdateMultipleInvoicingCategoryController